import React from "react";
import { Line, Bar, Doughnut } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, BarElement, ArcElement, Tooltip, Legend, Filler);

ChartJS.defaults.font.family = '"IBM Plex Sans Thai", "Noto Sans Thai", -apple-system, "Segoe UI", sans-serif';

export const CHART_COLORS = ["#0f766e", "#14b8a6", "#5eead4", "#f59e0b", "#e11d48", "#0ea5e9", "#64748b", "#a3e635"];

const baseOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: { legend: { display: false } },
  scales: {
    x: { grid: { display: false }, border: { color: "#e1e8e8" }, ticks: { font: { size: 11 }, color: "#5b6d6d" } },
    y: { border: { display: false }, grid: { color: "#eef3f3" }, ticks: { font: { size: 11 }, color: "#5b6d6d" } },
  },
};

export const LineChart = ({ labels = [], data = [], height = 240, label = "" }) => (
  <div style={{ height }}>
    <Line
      options={baseOptions}
      data={{
        labels,
        datasets: [
          {
            label,
            data,
            borderColor: CHART_COLORS[0],
            backgroundColor: "rgba(20,184,166,0.10)",
            fill: true,
            tension: 0.25,
            borderWidth: 2,
            pointRadius: 0,
            pointHoverRadius: 4,
          },
        ],
      }}
    />
  </div>
);

export const BarChart = ({ labels = [], data = [], height = 240, label = "", horizontal = false }) => (
  <div style={{ height }}>
    <Bar
      options={{ ...baseOptions, indexAxis: horizontal ? "y" : "x" }}
      data={{
        labels,
        datasets: [{ label, data, backgroundColor: CHART_COLORS[0], borderRadius: 3, maxBarThickness: 22 }],
      }}
    />
  </div>
);

export const DoughnutChart = ({ labels = [], data = [], height = 240 }) => (
  <div style={{ height }}>
    <Doughnut
      options={{
        responsive: true,
        maintainAspectRatio: false,
        cutout: "74%",
        plugins: { legend: { position: "bottom", labels: { boxWidth: 12, font: { size: 11 } } } },
      }}
      data={{ labels, datasets: [{ data, backgroundColor: CHART_COLORS, borderWidth: 0 }] }}
    />
  </div>
);
